export const NotFoundPage = (): JSX.Element => {
  return <div className={'items-center h-full w-full'}>{'Not Found'}</div>
}
